/*
 * Project: bellcloud
 * File: packages/utils/device/crc16.ts
 * Description: CRC-16 used by packet framing and log records (see packages/protocols/constants CRC_POLY)
 */

import { CRC_POLY } from '../../protocols/constants';

/**
 * CRC-16 over byte array (init 0x0000, polynomial CRC_POLY, MSB-first bit loop).
 * Same algorithm as BLE/Serial packet validation and LITE log record CRC.
 */
export function calculateCRC16(data: number[]): number {
  let crc = 0x0000;
  for (const byte of data) {
    crc ^= byte << 8;
    for (let i = 0; i < 8; i++) {
      if ((crc & 0x8000) !== 0) {
        crc = ((crc << 1) ^ CRC_POLY) & 0xffff;
      } else {
        crc = (crc << 1) & 0xffff;
      }
    }
  }
  return crc ^ 0x0000;
}
